import React, { Component } from 'react';
import ScrollMagic from 'scrollmagic';

import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap'
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators'

import './QuemSomosVisao.scss';

import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Fade from 'react-reveal/Fade';

import {
	TimelineMax,
	TweenMax
} from 'gsap';

import renderHTML from 'react-render-html';

import {
    Dispatcher,
    Actions,
    Events
} from '../../flux';

import {
	images,
	videos,
	views
} from '../../settings';

import {
	DelayLink,
	AnimatedVideo
} from '../../components/';

class QuemSomosVisao extends Component {

	constructor() {
		super();

        this.images = images;
        this.videos = videos;

        this.state = {
            width: window.innerWidth,
        	shadowOpacity: 'shown',
        	pathStrokeDasharray: 0,
        	pathStrokeDashoffset: 0
        };

        this.animDuration = (window.innerWidth <= 769) ? 1280 : 1280;

	    this.scrollTop = this.scrollTop.bind(this);

	    this.controller;
	    this.tween;
	    this.scene;
	}

	scrollTop() {
		this.refs.contentText.scrollTop = 0;
	}

    globalTransition() {
    	Actions.globalTransition();
    }

    setupVectors() {
    	let el = document.querySelector('#pathsvg');
    	let elHeight = el.getBoundingClientRect().height / 3;

    	let path = document.querySelector('#pathsvg path');
    	let length = path.getTotalLength();

    	let bodyHeignt = document.querySelector('body').offsetHeight;

 		// this.setState({ animDuration : bodyHeignt / 2 });
		this.setState({ pathStrokeDasharray : length });
		this.setState({ pathStrokeDashoffset : length });

		if (window.innerWidth < 768) {
			this.animDuration = 1280;
		} else {
			this.animDuration = 1280;
		}
    }

	componentWillMount() {
        this.controller = new ScrollMagic.Controller();

    	Actions.menuIntern();
    	Actions.logoIntern();
    	Actions.showFooter();
		Actions.emitPage('2.2 Visão, missão e valores');
    }

    componentDidMount() {
		this.setupVectors();

    	this.tween = new TimelineMax()
    		.add(TweenMax.to(this.refs.line_vector, 1, { strokeDashoffset: 0, ease: Linear.easeNone }));

    	this.scene = new ScrollMagic.Scene({ offset: (window.innerHeight / 2) - 80, triggerElement: this.refs.line_vector, duration: this.animDuration, tweenChanges: true})
    		.setTween(this.tween)
    		// .addIndicators()
    		.addTo(this.controller);

    }

	render() {
        const { width } = this.state;
        const isMobile = width <= 769;

		var classItem = [
			'view',
			'quemsomosvisao'
		];

		var pathStyles = {
			fill: 'none',
			strokeLinecap: 'round',
			strokeLinejoin: 'round',
			strokeDasharray: this.state.pathStrokeDasharray,
			strokeDashoffset: this.state.pathStrokeDashoffset,
			transform: 'translateX(10px)'
		};

		const media1 = (isMobile) ? <img src={ this.images.quem_somos_visao_img1 } className="quem_somos_visao_img1" /> : <AnimatedVideo mp4={ this.videos.visao_mp4 } /> ;
		const media2 = (isMobile) ? <img src={ this.images.quem_somos_visao_img2 } className="quem_somos_visao_img2" /> : <AnimatedVideo mp4={ this.videos.missao_mp4 } /> ;
		const media3 = (isMobile) ? <img src={ this.images.quem_somos_visao_img3 } className="quem_somos_visao_img3" /> : <AnimatedVideo mp4={ this.videos.valores_mp4 } /> ;

        return (

			<div className="views">
			
				<Helmet>
	                <title>2.2 Visão, Missão e Valores - Relatório Anual 2018 | ANBIMA</title>
	            </Helmet>

				<div className="views_container">
		        	<article className={ classItem.join(' ') }>

		        		<div className="vector_background">
							<svg id="pathsvg" xmlns="http://www.w3.org/2000/svg" width="1406" height="2247.271">
								<path 
									ref="line_vector"
									stroke="#F8DB56"
									strokeWidth="18"
									style={ pathStyles }
									d="M.5 0v114.65s9.818 119.625 118.066 119.625h1163.578c42.114 0 103.688 42.77 103.688 103.445v432.885c0 45.8-49.509 100.3-103.687 100.3s-1124.7-.961-1163.578-.961S3.315 897.802 1.68 978.577s0 364.722 0 414.984 38.465 110.438 108.406 111.344c58.2 0 1106.57 1.836 1163 1.836s112.32 47.548 112.32 109.8v412.7c0 48.565-38.819 109.664-106.809 109.59s-1124.043-1.375-1168.508-.637c-32.815.545-76.361 25.424-97 63.849a95.19 95.19 0 0 0-11.636 45.237" />
							</svg>
		        		</div>

		        		<header className="views__header">
		        			<div className="container">
				        		<h1><span>2.2</span> Visão, missão e valores</h1>
		        			</div>
		        		</header>

		        		<header className="views__breadcrumb">
		        			<div className="container">
				        		<p>Home / Quem somos</p>
		        			</div>
		        		</header>


		        		<div className="views__content row negative-margin">
			        		<div className="container">
			        			<div className="horizontal_separator horizontal_separator--left">
					        		<span className="gri_label"><text>GRI 102-16</text></span>
					        		
				        			<div className="separator__curve separator__curve--02">
				        			</div>
				        			<div className="separator__line">
				        			</div>
				        			<div className="separator__curve separator__curve--04">
				        			</div>
			        			</div>
			        		</div>
		        		</div>

		        		<div className="views__content views__content--visao row">
			        		<div className="container">
			        			<div className="bordered-content bordered-content--right views__content--static">

					        		<div className="column column--half text-center column--s_first">
					        			<Fade bottom>
			        						<h2>Visão</h2>
					        			</Fade>
					        			<Fade bottom>
			        						<p>Mercado forte se faz com instituições fortes.</p>
					        			</Fade>
					        		</div>
				        			
					        		<div className="column column--half text-center column--s_last">
					        			<Fade bottom>
					        				{media1}
					        			</Fade>
					        		</div>
			        			</div>
			        		</div>
		        		</div>

 
		        		<div className="views__content row">
			        		<div className="container">
			        			<div className="horizontal_separator horizontal_separator--right">
				        			<div className="separator__curve separator__curve--03">
				        			</div>
				        			<div className="separator__line">
				        			</div>
				        			<div className="separator__curve separator__curve--01">
				        			</div>
			        			</div>
			        		</div>
		        		</div>

		        		<div className="views__content views__content--missao row">
			        		<div className="container">
			        			<div className="bordered-content bordered-content--left views__content--static">
				        			
					        		<div className="column column--half text-center column--s_first">
					        			<Fade bottom>
					        				{media2}
					        			</Fade>
					        		</div>

					        		<div className="column column--half text-center column--s_last">
					        			<Fade bottom>
			        						<h2>Missão</h2>
			        						<p>Fortalecer a representação do setor e apoiar a evolução de um mercado de capitais capaz de financiar o desenvolvimento econômico e social local e influenciar o mercado global.</p>
					        			</Fade>
					        		</div>
			        			</div>
			        		</div>
		        		</div>


		        		<div className="views__content row">
			        		<div className="container">
			        			<div className="horizontal_separator horizontal_separator--left">
				        			<div className="separator__curve separator__curve--02">
				        			</div>
				        			<div className="separator__line">
				        			</div>
				        			<div className="separator__curve separator__curve--04">
				        			</div>
			        			</div>
			        		</div>
		        		</div>

		        		<div className="views__content views__content--valores row">
			        		<div className="container">
			        			<div className="bordered-content bordered-content--right views__content--static">

					        		<div className="column column--half text-center column--s_first">
					        			<Fade bottom>
			        						<h2>Valores</h2>
					        			</Fade>
			        					<p>
		        							<ul>
				        						<Fade bottom cascade>
			        								<li>Cooperação</li>
													<li>Excelência</li>
													<li>Inovação</li>
													<li>Integridade</li>
													<li>Pluralidade</li>
													<li>Responsabilidade</li>
					        					</Fade>
		        							</ul>
		        						</p>
					        		</div>
				        			
					        		<div className="column column--half text-center column--s_last">
					        			<Fade bottom>
					        				{media3}
					        			</Fade>
					        		</div>
			        			</div>
			        		</div>
		        		</div>

 
		        		<div className="views__content row">
			        		<div className="container">
			        			<div className="horizontal_separator horizontal_separator--right">
				        			<div className="separator__curve separator__curve--03">
				        			</div>
				        			<div className="separator__line">
				        			</div>
				        			<div className="separator__curve separator__curve--01">
				        			</div>
			        			</div>
			        		</div>
		        		</div>


		        	</article>

        		</div>
    		</div>
    	);
	}
}

export { QuemSomosVisao };
